import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { StoreService } from '../../services/store.service';
import { DataService } from '../../services/data.service';
import { ToolsService } from 'src/app/services/tools.service';
import { BaseCheckoutComponent } from '../base-components/base-checkout';
import { pages, WaiverSteps } from '../../alv-enums';
import { WaiverService } from 'src/app/services/waiver.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Router } from '@angular/router';

@Component({
	selector: 'checkout-header',
	templateUrl: './checkout-header.component.html',
	styleUrls: ['./checkout-header.component.scss']
})
export class CheckoutHeaderComponent extends BaseCheckoutComponent implements OnInit, OnChanges {

	@Input() public currentPage: pages;

	public pageTitle: string;
	public reviewOrderClass: string;
	public customerInfoClass: string;
	public waiverClass: string;
	public payClass: string;
	public receiptClass: string;
	

	/** This is here to allow the html code to access the pages enum. */
	public pagesEnum: any;
    stepNumber:number=0;
	constructor(public storeService: StoreService
		, public dataService: DataService
		, protected toolsService: ToolsService
		, protected waiverService: WaiverService
		, protected recaptchaV3Service: ReCaptchaV3Service 
		, protected router: Router
	) {
		super(dataService, storeService, toolsService, waiverService, recaptchaV3Service, router);
		this.pagesEnum = pages;
		this.pageTitle = 'Review Order';
		this.reviewOrderClass = 'active';
	}

	ngOnInit() { }

	ngOnChanges(changes: SimpleChanges) {
		this.onPageChange();
	}

	goToPage(page: pages, clickedOnNumber: boolean = false) {		
		const self = this;
		switch (page) {
			case pages.Order:
				if (self.currentPage < pages.Receipt) {
					self.pageChange.emit(page);
				}
				break;
			case pages.ReviewOrder:
				if (self.currentPage < pages.Receipt) {
					self.pageChange.emit(page);
				}
				break;
			case pages.CustomerInfo:
				if ((!clickedOnNumber || self.currentPage !== pages.ReviewOrder) && (self.currentPage < pages.Receipt)) {
					self.pageChange.emit(page);
				}
				break;
			case pages.Waiver:
				if (self.currentPage < pages.Pay) {
					self.pageChange.emit(page);
				}
				break;
		}
		window.scroll(0,0)
	}

	goBack() {
		const self = this;

		switch (self.currentPage) {
			case pages.ReviewOrder:
				self.pageChange.emit(pages.Order);
				break;
			case pages.CustomerInfo:
				self.pageChange.emit(pages.ReviewOrder);
				break;
			case pages.Waiver:
				//if on email go to previous step
				if(self.waiverService.currentWaiverStep == WaiverSteps.email)
				{
					if(self.storeService.kioskSettings.hideInfoStep)
					{
						self.pageChange.emit(pages.Order)
					}
					else{
						self.pageChange.emit(pages.CustomerInfo)
					}
				}
				//else step back into the waiver
				self.waiverService.onStepChangeBackwords();
				break;
			case pages.Pay:
				if(self.storeService.kioskSettings.waiverRequired)
				self.pageChange.emit(pages.Waiver);
				else{
					if(self.storeService.kioskSettings.hideInfoStep)
					{
						self.pageChange.emit(pages.Order)
					}
					else{
						self.pageChange.emit(pages.CustomerInfo)
					}
				}
				break;
		}
		window.scroll(0,0)
	}

	onPageChange() {
		const self = this;

		switch (self.currentPage) {
			case pages.ReviewOrder:
				self.pageTitle = 'Review Order';
				self.reviewOrderClass = 'active';
				self.customerInfoClass = '';
				self.waiverClass = '';
				self.payClass = '';
				self.receiptClass = '';
				break;
			case pages.CustomerInfo:
				self.pageTitle = 'Information';
				self.reviewOrderClass = 'completed';
				self.customerInfoClass = 'active';
				self.waiverClass = '';
				self.payClass = '';
				self.receiptClass = '';
				break;
			case pages.Waiver:
				self.pageTitle = 'Waiver';
				self.reviewOrderClass = 'completed';
				self.customerInfoClass = 'completed';
				self.waiverClass = 'active';
				self.payClass = '';
				self.receiptClass = '';
				break;
			case pages.Pay:
				self.pageTitle = 'Pay';
				self.reviewOrderClass = 'completed';
				self.customerInfoClass = 'completed';
				self.waiverClass = 'completed';
				self.payClass = 'active';
				self.receiptClass = '';
				break;
			case pages.Receipt:
				self.pageTitle = 'Receipt';
				self.reviewOrderClass = 'completed';
				self.customerInfoClass = ' completed';
				self.waiverClass = 'completed';
				self.payClass = 'completed';
				self.receiptClass = 'active';
				break;
			case pages.ThankYou:
				self.pageTitle = 'Thank You';
				self.reviewOrderClass = 'completed';
				self.waiverClass = 'completed';
				self.customerInfoClass = ' completed';
				self.payClass = 'completed';
				self.receiptClass = 'completed';
				break;
		}
	}

	getStepNumber() :Number
	{
		this.stepNumber = this.stepNumber + 1;
		return this.stepNumber;
	}

	resolved(token){
		this.checkoutOrder(token, 2)
	}

}
